
import Component from '../src/components/Internal/ExternalAdUnitAutoweb.vue';

// Register component globally without any prefix if Vue is available.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('external-ad-unit-autoweb', Component);
}

export default Component;
    